// ⚠️ 레거시 — SubscribeToPass 전용 약관 안내. /subscribe 와 함께 정리 대상.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
const Notice = (param)=>{
    let { title , caution , className  } = param;
    const isArray = Array.isArray(caution);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("relative max-h-[90px] overflow-auto rounded-md", className),
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "typo-subtitle2 text-gray-500",
                children: title
            }),
            isArray ? /*#__PURE__*/ _jsx("ul", {
                className: "mt-2 list-disc pl-6",
                children: caution.map((item, index)=>/*#__PURE__*/ _jsx("li", {
                        className: "typo-body2 leading-[22px] text-gray-500",
                        children: item
                    }, index))
            }) : /*#__PURE__*/ _jsx("p", {
                className: "typo-caption text-secondary mt-2 whitespace-pre-wrap",
                children: caution
            })
        ]
    });
};
export default Notice;
